export enum ScoreCardType {
    COUNT = 'COUNT',
    GRADE = 'GRADE',
    TIME_HH_MM = 'TIME_HH_MM',
    TIME_MM_SS = 'TIME_MM_SS',
    TIME_HH_MM_SS = 'TIME_HH_MM_SS',
    PERCENTAGE = 'PERCENTAGE',
    BOOLEAN = 'BOOLEAN',
}

export interface ScoreCardFormData {
  name: string;
  description?: string;
  memberEditAccess: boolean;
  containsAllMembers?: boolean;
  selectedUserIds?: number[];
  ascending?: boolean;
  type: ScoreCardType;
};

export type ScoreCardScoreModel = {
  scoreCardId?: number;
  memberId: number;
  score: number;
  lastUpdated: string | Date;
  firstName?: string;
  lastName?: string;
  userId?: number;
  type: ScoreCardType;
};

type ScoreCardBaseInfo = {
  communityId: number;
  name: string;
  description?: string;
  picture?: string;
  memberEditAccess: boolean;
  containsAllMembers: boolean;
  selectedUserIds?: number[];
  lastUpdated: string | Date;
  ascending: boolean;
  type: ScoreCardType;
};

export type ScoreCard = ScoreCardBaseInfo & {
  scoreCardId: number;
  scores: ScoreCardScoreModel[];
  totalScore: number;
  type: ScoreCardType;
};

export type ScoreCardOnB2CConnection = {
  scoreCardId: number;
  connectionId: number;
  score: number;
  lastUpdated: string | Date;
};

export type ScoreCardOnB2CConnectionData = ScoreCardOnB2CConnection & {
  b2cConnection: {
    user: {
      userId: number;
      firstName: string;
      lastName: string;
    };
  };
};

export type ScoreCardCreateInfo = Omit<ScoreCardBaseInfo, 'lastUpdated'>;
export type ScoreCardUpdateInfo = Partial<Omit<ScoreCardBaseInfo, 'communityId'|'type'>>;
export type ScoreOnParticipationCreateInfo = Omit<
  ScoreCardOnB2CConnection,
  'score' | 'lastUpdated'
>;
export type ScoreOnParticipationUpdateInfo = Omit<
  ScoreCardOnB2CConnection,
  'scoreCardId' | 'connectionId'
>;
export type GetAllScoreCardsResponse = ScoreCard[];

